import { Calendar, Users, Plus, Edit3, Trash2 } from "lucide-react";

export default function AdminEventsTab({
  communityEvents,
  onAddEvent,
  onEditEvent,
  onDeleteEvent
}) {
  return (
    <div className="bg-white rounded-xl shadow-sm overflow-hidden">
      <div className="p-4 border-b border-gray-100 flex items-center justify-between">
        <div>
          <h3 className="font-semibold text-gray-900 flex items-center gap-2">
            <Calendar className="w-5 h-5 text-brand" /> Community Events
          </h3>
          <p className="text-sm text-gray-500 mt-1">Manage meetups and events for the remote work community</p>
        </div>
        <button
          onClick={onAddEvent}
          className="flex items-center gap-2 px-3 py-1.5 bg-brand text-white text-sm rounded-lg hover:bg-brand-dark transition-colors"
          data-testid="add-event-btn"
        >
          <Plus className="w-4 h-4" />
          Add Event
        </button>
      </div>
      
      <div className="divide-y divide-gray-100">
        {communityEvents.length === 0 ? (
          <div className="p-8 text-center text-gray-500">
            <Calendar className="w-12 h-12 mx-auto mb-2 opacity-30" />
            <p>No community events yet. Create your first event!</p>
          </div>
        ) : communityEvents.map((event) => (
          <div key={event.id} className={`p-4 ${!event.is_active ? 'bg-gray-50 opacity-60' : ''}`}>
            <div className="flex items-start justify-between gap-4">
              <div className="flex-1">
                <div className="flex items-center gap-2">
                  <h4 className="font-semibold text-gray-900">{event.title}</h4>
                  {event.recurring && (
                    <span className="px-2 py-0.5 bg-blue-100 text-blue-700 text-xs rounded-full">{event.recurring}</span>
                  )}
                  {!event.is_active && (
                    <span className="px-2 py-0.5 bg-gray-200 text-gray-600 text-xs rounded-full">Inactive</span>
                  )}
                </div>
                <p className="text-sm text-gray-600 mt-1">{event.location}, {event.city}</p>
                <div className="flex items-center gap-4 mt-2 text-xs text-gray-500">
                  <span className="flex items-center gap-1">
                    <Calendar className="w-3 h-3" /> {new Date(event.date).toLocaleDateString('en-GB')} at {event.time}
                  </span>
                  <span className="flex items-center gap-1">
                    <Users className="w-3 h-3" /> {event.attendee_count || 0} attending
                    {event.max_attendees && ` / ${event.max_attendees} max`}
                  </span>
                </div>
                {event.description && (
                  <p className="text-sm text-gray-700 mt-2 bg-gray-50 p-2 rounded">{event.description}</p>
                )}
              </div>
              <div className="flex gap-2">
                <button
                  onClick={() => onEditEvent(event)}
                  className="p-2 text-gray-500 hover:text-brand hover:bg-gray-100 rounded-lg"
                >
                  <Edit3 className="w-4 h-4" />
                </button>
                <button
                  onClick={() => onDeleteEvent(event.id)}
                  className="p-2 text-gray-500 hover:text-red-600 hover:bg-red-50 rounded-lg"
                >
                  <Trash2 className="w-4 h-4" />
                </button>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
